import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

import Cookies from 'js-cookie'

import  useUserSettingStore from '../../../stores/UserSettingsStore';
import useSettingsStore from '../../../stores/SettingsStore';
import { IoMdCloseCircle } from "react-icons/io";

function CreateTrade(props) {
  const coin = props.coin
  const position = props.position
  const exchange = props.exchange
  const side = props.side
  const coinName = props.coinName
  const coinNumber = props.coinNumber 
  const show = props.show
  const setShow = props.setShow
  const size = props.size
  const prefix = props.prefix
  const avgPrice = props.avgPrice

  const clearSelectedSettingStore = useSettingsStore((state) => state.clearSelectedSetting)
  const settings = useSettingsStore((state) => state.settings)
  const selectSetting = useSettingsStore((state) => state.selectSetting)
  const selectedSetting = useSettingsStore((state) => state.selectedSetting)
  const fetchUserSettings = useUserSettingStore((state) => state.fecthUserSettings)
  const stop_settings_list = useSettingsStore((state) => state.stopSettingList)

  const [selectedAccordion, setSelectedAccordion] = useState("Stop Settings")
  const [filledStopInput, setFilledStopInput] = useState({})
  const [stopSettings, setStopSettings] = useState({})

  const [percentage, setPercentage] = useState(100);

  const [createTradeQuantity, setCreateTradeQuantity] = useState(0)
  const stop_input_list = ["stop_price", , "exit_price", 'trigger_instrument']

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchUserSettings();
      } catch (error) {
        console.log("Error fetching user settings", error);
      }
    };
    
    fetchData();

    if (selectedSetting && Object.keys(selectedSetting).length !== 0) {

      setStopSettings((prevStopSettings) => ({
        ...prevStopSettings,
        ...selectedSetting.stop_settings,
      }));
    } else {

      selectSetting("DEFAULT")
 
    }
}, [selectedSetting, fetchUserSettings]);

  // STOP SETTINGS
  const data_accordion = {"Stop Settings": stop_settings_list}
  const accordion2 = {"Stop Settings": stop_settings_list}
  const toggleAccordion = (option) => {
    if (selectedAccordion === option) {
        return setSelectedAccordion(null)
    }
    setSelectedAccordion(option)
  }
  
  const handleStopChange = (event) => {
    const name = event.target.name 
    const value = event.target.value 
    setStopSettings((prevStopSettings) => ({
        ...prevStopSettings,
        [name]: value,
    }))
  }
  const clearSelectedSetting = () => {
  const input_list = [  "setting_name","max_order_size", "cancel_price_gap", "stop_max_order_size","price_limit_is_last_ex_price","fill_delay","depth_min","depth_max", "rdm_qty_range", "aggro_order_on","aggro_depth","aggro_order_delay","aggro_book_ratio","aggro_forced_if_no_fill_in", "stop_settings"]
    setStopSettings({})
    clearSelectedSettingStore()
  }

  // FORM
  const handleSliderChange = (event) => {
    const percent = event.target.value
    setPercentage(percent);
    if (percent == 100) {
      setCreateTradeQuantity(size)
    }else if ( percent == 0) {
    
      setCreateTradeQuantity(0)
    
    } else{
    const quantity = (percentage * size / 100)
    const correctValue = Number((quantity).toFixed(5))
    setCreateTradeQuantity(correctValue)
    }
  };
  const handleQuantityChange = (e) => {
    const quantity = e.target.value
    setCreateTradeQuantity(e.target.value)
    const percent = quantity / size
    setPercentage(percent)
  }
  const handlePercentChange = (percent) => {
    setPercentage(percent)
    const quantity = (percent * size / 100)
    const correctValue = Number((quantity).toFixed(5))
    setCreateTradeQuantity(correctValue)
  }
  const handleStopInputChange = (e) => {
    const {name, value} = e.target
    setFilledStopInput((prevFilledInput) => ({
      ...prevFilledInput,
      [name]: value,
      })
    )
  }
    
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    
    const payload = {
      "exchange": exchange,
      "pair": coin,
      "quantity": createTradeQuantity,
      "settings": stopSettings,
    }
    if (createTradeQuantity === 0) {
      if (percentage === 100) {
        payload["quantity"] = size
      }
    }
    
    Object.keys(filledStopInput).map(function(input) {
      return(
        payload[input] = filledStopInput[input]
      )
    }) 
    console.log('Payload', payload)
    const token = Cookies.get('token')
    try {
      const response = await axios({
          headers: { Authorization: token },
          method: "POST",
          url : "/api/stop_position",
          data : payload
      })
      if (response.status === 200) {
         
          console.log('Sent stop position')
          setShow(!show)
      }
    } catch (err) {
    console.log('ERROR', err)     
    }
    
 
    };
    
  return (
    <div>
      <form className='modal_form_container' onSubmit={handleSubmit}>
        <div className="create_trade_input_container">
          <h3 className='modal_input_title'>Quantity  </h3>
           <input className="input modal_input"  value={percentage === 100 ? size : createTradeQuantity} onChange={(e) => handleQuantityChange(e)}/>
        </div>
        <div className="create_trade_input_container">
          <input className="slider_percentage" type="range" id="percentage-slider" name="percentage" min="1" max="100" value={percentage} onChange={handleSliderChange} />
          <span className="percentage_display">{percentage}%</span>
          
        </div>
        <div className="create_trade_input_container">
        <ul className="percent_button_container">
            <li className="percent_button li"  onClick={()=> handlePercentChange(25)}>25%</li>
            <li className="percent_button li"  onClick={()=> handlePercentChange(50)}>50%</li>
            <li className="percent_button li" onClick={()=> handlePercentChange(75)}>75%</li>
            <li className="percent_button li" onClick={()=> handlePercentChange(100)}>100%</li>
          </ul>
        </div>
        {stop_input_list.map((input, i) => 
          <div className="create_trade_input_container">
            <h3 className="modal_input_title">{input.replaceAll("_", " ")}</h3>
            <input  className="input modal_input" value={filledStopInput[input] || ""} name={input} onChange={(e)=> handleStopInputChange(e)} />
          </div>
        )}
        <div className="settings_list_container">
          <h3 className='modal_input_title'>Stop Settings</h3>
          <ul className=" form_radio_container">
          {Object.keys(settings).map(function(setting) {
                  return(
                  <li className={selectedSetting &&  selectedSetting["setting_name"] === setting ? "li li_setting active_li_setting no_drag" : "li li_setting no_drag"}  key={setting}>
                      <p key={setting+"input"} className="no_drag setting_name" onClick={() => selectSetting(setting)}>{setting.replaceAll('_', ' ')}</p>
                     {selectedSetting &&  selectedSetting["setting_name"] === setting ? <IoMdCloseCircle className="no_drag close_selected_setting" onClick={() => clearSelectedSetting(setting)}/> : null}
                </li>)
              })
          }  
          </ul>
      </div>
        <div className="accordion accordion_positions" id="trade_stop_settings">
          {Object.keys(accordion2).map(function(option, i) {
              return(
                  <div className='item' key={"item" +i}>
                      <div className="title no_drag" key={"title" + i} onClick={() => toggleAccordion(option)}>
                          <h3 key={"h3_" +i}>{option}</h3>
                          <span key={"span_" +i}>{selectedAccordion === option ? "-" : "+"}</span>

                    </div>
                    {data_accordion[option].map((item, j) => 
                    
                    <div key={"content2_trade" +j} className={selectedAccordion === option ? "content show" : "content"}>
                        <p className="accordion_p" key={"p" +j}>{item.replaceAll('_', ' ')}</p>
                        <input key={"input_" +j} className="input no_drag" name={item} id={option} value={stopSettings[item] || ''} onChange={(e) => handleStopChange(e)} type="text" />
                        {/* <div key={"icon" +j} className="info_icon" id={item +"_stop_"} onMouseOver={(e) => showDetails(e)} onMouseLeave={(e) => hideDetails(e)}>ⓘ</div> */}
                        {/* <p key={"detail" +j} name={item} id={item + "_stop_details"} className="input_details hide_details">{details[item]}</p> */}
                        
                    </div>
                    )}
                  </div>
                )
            })}
        </div>

     
      <button className="btn modal_submit" type="submit">Create</button>
      
    </form>
    </div>
  )
}

export default CreateTrade